// emitter.ts
type EventHandler = (payload: any) => void;

const listeners = new Map<string, Set<EventHandler>>();

export function emit(name: string, payload?: any) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(name, { detail: payload }));
}

export function on(name: string, handler: EventHandler) {
  if (typeof window === 'undefined') return;

  const listener = (e: Event) => handler((e as CustomEvent).detail);

  if (!listeners.has(name)) {
    listeners.set(name, new Set());
  }
  listeners.get(name)!.add(handler);

  // Gerçek tarayıcı dinleyicisini daha sonra kaldırabilmek için
  // handler üzerinde bir özellik olarak sakla
  (handler as any).__listener = listener;

  window.addEventListener(name, listener);
}

/**
 * Belirtilen olay (event) için kaydedilmiş TÜM dinleyicileri kaldırır.
 * @param name Kaldırılacak olayın adı.
 */
export function off(name: string, handler?: EventHandler) {
  if (typeof window === 'undefined') return;

  const handlers = listeners.get(name);
  if (!handlers) return;

  if (handler) {
    const actualListener = (handler as any).__listener;
    if (actualListener) {
      window.removeEventListener(name, actualListener);
    }
    handlers.delete(handler);

    if (handlers.size === 0) {
      listeners.delete(name);
    }
    return;
  }

  // Belirtilen 'name' için kaydedilmiş handler'ları dolaş
  for (const handler of handlers) {
    // 'on' fonksiyonunda saklanan asıl tarayıcı dinleyicisini al
    const actualListener = (handler as any).__listener;
    if (actualListener) {
      window.removeEventListener(name, actualListener);
    }
  }

  // Map'ten bu olayın kaydını sil
  listeners.delete(name);
}
